import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Menu, X, Phone, MapPin } from "lucide-react";
import { shop } from "../../data";

const navLinks = [
  { label: "Il Negozio", href: "/#about" },
  { label: "Collezioni", href: "/#categorie" },
  { label: "Recensioni", href: "/#recensioni" },
  { label: "Contatti", href: "/#contatti" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "glass border-b border-[#123D5B]/5 py-3" : "py-6"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between">
        <a
          href="/#top"
          data-testid="logo-link"
          className="flex items-center gap-3"
        >
          <img
            src="/logo.jpg"
            alt="La casa del pigiama"
            className="h-12 w-12 md:h-14 md:w-14 object-contain rounded-lg"
          />
          <span className="hidden sm:flex flex-col leading-none">
            <span className="font-serif text-xl md:text-2xl font-500 tracking-tight text-[#123D5B]">
              La casa del pigiama
            </span>
            <span className="text-[10px] tracking-[0.3em] uppercase text-[#C24E77] mt-1">
              Novara · dal cuore della città
            </span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {navLinks.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className={
                l.highlight
                  ? "inline-flex items-center gap-1.5 text-sm font-600 text-[#C24E77] hover:text-[#a83b62] transition-colors duration-300"
                  : "text-sm text-[#4A5863] hover:text-[#C24E77] transition-colors duration-300"
              }
            >
              {l.highlight && <span className="w-1.5 h-1.5 rounded-full bg-[#C9A25A] animate-pulse" aria-hidden="true" />}
              {l.label}
            </a>
          ))}
          <a
            href={shop.phoneHref}
            data-testid="header-call-button"
            className="inline-flex items-center gap-2 bg-[#123D5B] hover:bg-[#0C2A40] text-white text-sm rounded-sm px-5 py-2.5 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_8px_32px_rgba(18,61,91,0.25)]"
          >
            <Phone size={15} aria-hidden="true" /> Chiama Ora
          </a>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen(!open)}
          className="md:hidden text-[#123D5B] p-2"
          aria-label="Menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden glass border-t border-[#123D5B]/5 mt-3"
        >
          <div className="px-6 py-6 flex flex-col gap-5">
            {navLinks.map((l) => (
              <a
                key={l.label}
                href={l.href}
                onClick={() => setOpen(false)}
                className={l.highlight ? "text-base font-600 text-[#C24E77]" : "text-base text-[#123D5B]"}
              >
                {l.label}
              </a>
            ))}
            <div className="flex flex-col gap-3 pt-2">
              <a
                href={shop.phoneHref}
                className="inline-flex items-center justify-center gap-2 bg-[#123D5B] text-white rounded-sm px-5 py-3"
              >
                <Phone size={16} aria-hidden="true" /> {shop.phone}
              </a>
              <a
                href={shop.mapsUrl}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center justify-center gap-2 border border-[#C24E77]/40 text-[#C24E77] rounded-sm px-5 py-3"
              >
                <MapPin size={16} aria-hidden="true" /> Come raggiungerci
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
